/**
 * components/tableElements/ResultsInfo.jsx
 */

import { __, _n } from "@wordpress/i18n";
import { useCrudListState } from "../../context/CrudContext";

export default function ResultsInfo() {
    const state = useCrudListState();
    const count = state.items.length;

    return (
        <div className="px-4 sm:px-6 py-3 bg-white border-b border-gray-200">
            <div className="flex items-center justify-between text-sm text-gray-600">
                <span>
                    {count} {_n("item", "items", count, "wpbean-product-gallery-slider-for-woocommerce")}
                </span>
                {state.selected.length > 0 && (
                    <span>{state.selected.length} {__("selected", "wpbean-product-gallery-slider-for-woocommerce")}</span>
                )}
            </div>
        </div>
    );
}
